import { Component } from '@angular/core';
import { NavParams, ToastController } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';

@Component({
  selector: 'share-pdf',
  templateUrl: 'share-pdf.html'
})
export class SharePdfPopover {
  constructor(public navParams: NavParams, private socialSharing: SocialSharing, private toastCtrl: ToastController) {}

  pdfMail() {
    let pdfData = this.navParams.get("pdfData");

    this.socialSharing.shareViaEmail("", "", ["test@asdf.at"], [""], [""], pdfData).then(() => {
      console.log("can share - Email");
    }).catch(() => {
      this.presentToast("PDF kann auf diesem Gerät nicht über E-Mail geteilt werden.");
    });
    //location.href = "mailto:&body=" + pdfData";
  }

  pdfWhatsApp() {
    this.socialSharing.shareViaWhatsApp("message", "", "").then(() => {
      console.log("can share - WhatsApp");
    }).catch(() => {
      this.presentToast("PDF kann auf diesem Gerät nicht über WhatsApp geteilt werden.");
    });
    //location.href = "https://wa.me/?text=" + pdfData;
  }

  presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/popovers/share-pdf/share-pdf.ts